<template>

	<div
		class="keyword-stats"
	>

		<div
			v-for="(tab, tabIndex) in tabsProcessed" 
			:key="tabIndex"
			:class="{'keyword-stat': true, hide: hide(tab) }"
			@click="click(tab)"
		>
			<NumberTotalDoughnut
				donutSize="small"
				:total="tab.stats.count"
				:label="label(tab)" 
				:class="{doughnut:true,noCount:tab.stats.count===0}"
				:loading="loading ( tab )"
			/>

			<div class="content">

				<h2 class="title" v-html="title[tab.type]" />

				<span 
					:class="[{status:true}, statusColour(tab)]" 
					v-html="statusText(tab)" 
				/> 

				<span 
					:class="[{status:true,orange2:true}]" 
					v-html="showCost(tab)"
					v-if="showCost(tab)"
				/>

				<p v-html="tabText(tab)" />

			</div>
		</div>

	</div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import NumberTotalDoughnut from './..//Data/NumberTotalDoughnut.vue'
export default {
	name: 'KeywordStats',
	components: { NumberTotalDoughnut },
	props: {
		tabs: {
			type: Array
		},
		md5Key: {
			type: String
		},
		keyword: {
			type: String
		}
	},
	data() {

		return {
			
		}

	},
	watch: {
		
	},
	computed: {

		...mapState('general',['dateTimeFormat','analysisCreditsInfo']),

		hasQuestions () {

			let q = this.tabs.find ( tab => tab.type === 'questions' );

			return ( typeof q.stats !== 'undefined' && typeof q.stats.status !== 'undefined' && q.stats.status === 'complete' );

		},

		title () {

			return {
				overview: 'Keyword Ideas',
				questions: 'Questions',
				popular: 'Popular Filters',
				paa: 'People Also Ask',
				auto: 'Auto-Suggest',
				'content-ideas': 'Supporting Content Ideas',
				'to-improve': 'To Improve',
				'topic-cluster': 'Topic Cluster'
			}

		},

		globalStatus () {

			return this.tabs[0].stats.status;

		},

		analysisCreditsInfoIsLoaded () {
			
			return !!this.analysisCreditsInfo && !!this.analysisCreditsInfo.costs;

		},

		tabsProcessed () {

			let tabs = [];

			for ( let tab of this.tabs ) {

				if ( tab.type === 'easy' ) continue;

				if ( this.globalStatus !== 'complete' && ['overview','questions','popular'].indexOf( tab.type ) < 0 ) continue;

				if ( !tab.stats ) tab.stats = {};

				tab.stats.count = tab.stats.count || 0;

				if ( tab.type === 'overview' && tab.stats.status === 'complete' && !this.hasQuestions ) {

					tab.stats.status = 'semi-complete';

				}

				tabs.push(tab);

			}

			return tabs;

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText','reloadInstructionalTips']),

		click(tab) {

			this.$router.push({ path: `/content-and-keywords/${tab.type}/${this.md5Key}/${tab._id}` });

		},

		label ( tab ) {

			const alts = {
				popular: 'Filters',
				overview: 'Ideas',
				questions: 'Questions',
				paa: 'Questions',
				'content-ideas': 'Ideas'
			}

			return tab.type in alts ? alts[tab.type] : 'Results';

		},

		hide ( tab ) {

			if ( tab.type === 'easy' ) return true;

			if ( this.globalStatus !== 'complete' && ['overview','questions','popular'].indexOf( tab.type ) < 0 ) return true;

			return false;

		},

		loading ( tab ) {

			return ['pending','in-progress','semi-complete'].indexOf( this.status (tab) ) >= 0;

		},

		statusColour ( tab ) {

			const status = this.status (tab);

			let c = 'grey', rtn = {};

			if ( status === 'complete' ) c = 'green';

			if ( status === 'error' || status === 'not-found' ) c = 'red';

			if ( status === 'pending' || status === 'in-progress' || status === 'semi-complete' ) c = 'orange';

			rtn[c] = true;

			return rtn;

		},

		showCost ( tab ) {

			if ( this.analysisCreditsInfoIsLoaded && this.status (tab) === 'not-run' ) {
				
				if ( this.analysisCreditsInfo.costs[tab.type] && this.analysisCreditsInfo.costs[tab.type] > 0 ) {

					return this.analysisCreditsInfo.costs[tab.type] + ' Credit' + ( this.analysisCreditsInfo.costs[tab.type] > 1 ? 's' : '' );

				}

				return 'Free';

			}

			return '';

		},

		status (tab) {

			let status = tab.stats.status || 'not-run';

			if ( status === 'not-run' && !!tab.type && ( tab.type === 'questions' || tab.type === 'popular' ) ) {

				let overviewTab = this.tabs.find ( tab => tab.type === 'overview' );

				status = this.status (overviewTab);

			}

			return status;

		},

		statusText ( tab ) {
			
			const status = this.status (tab);

			if ( status === 'complete' ) return 'Complete';

			if ( status === 'semi-complete' ) return 'Semi-Complete';

			if ( status === 'error' ) return 'Error';

			if ( status === 'not-found' ) return 'Not Found';

			if ( status === 'pending' || status === 'in-progress' ) return 'In Progress';

			return 'Not Run';

		},

		tabText ( tab ) {

			const status = this.status (tab);

			if ( status === 'error' ) return "This failed to run. Please try again, if you continue to have issues please contact us.";

			if ( status === 'pending' ) return "Your results will be ready shortly.";

			if ( status === 'semi-complete' || status === 'complete' || status === 'not-found' ) {

				switch ( tab.type ) {

					case 'overview':

						if ( status === 'semi-complete' ) return `We are fetching more ideas This won't take long (you can view <strong>${tab.stats.count}</strong> right now).`;

						return `You have <strong>${tab.stats.count}</strong> ideas related to <strong>${this.keyword}</strong>.`;

					case 'questions':

						if ( status === 'semi-complete' && tab.stats.count === 0 ) return ''; 

						return `You have <strong>${tab.stats.count}</strong> questions related to <strong>${this.keyword}</strong>.`;

					case 'popular':

						if ( status === 'semi-complete' && tab.stats.count === 0 ) return ''; 
						
						return `You have <strong>${tab.stats.count}</strong> popular filters related to <strong>${this.keyword}</strong>.`;

					case 'auto':

						let r = `You have <strong>${tab.stats.count}</strong> Auto-Suggest results...<br /> `;

						Object.keys( tab.stats.meta.countBreakdown ).forEach ( ( k, i ) => {

							if ( i === 1 ) r += ', ';

							if ( i === 2 ) r += ' &amp; ';

							r += `<strong>${tab.stats.meta.countBreakdown[k]}</strong> ${k}`;

						});

						return r + '.';

					case 'paa' :

						if ( tab.stats.count === 0 ) {

							return `We couldn't find any People Also Ask questions for your keyword, if you think this is an error please contact us.`;

						}

						return `You have <strong>${tab.stats.count}</strong> People Also Ask questions related to <strong>${this.keyword}</strong>.`;

					case 'content-ideas':

						if ( tab.stats.count === 0 ) {

							return `We couldn't find any Supporting Content Ideas for your keyword, if you think this is an error please contact us.`;

						}

						let r2 = `You have <strong>${tab.stats.count}</strong> Supporting Content Ideas...<br /> `;

						if ( tab.stats.meta ) {

							Object.keys( tab.stats.meta.domains ).forEach ( ( domain, i ) => {

								let ii = Object.keys( tab.stats.meta.domains ).length - 2;

								r2 += `<strong>${tab.stats.meta.domains[domain]}</strong> for <strong>${domain}</strong>`;

								if ( i < ii ) r2 += ', <br />';

								if ( i === ii ) r2 += ' &amp; <br />';

							});

							r2 += '.';

						}

						return r2;

					case 'to-improve' :

						return `You have <strong>${tab.stats.count}</strong> keywords to improve.`;

					case 'topic-cluster' :

						return `You have <strong>${tab.stats.count}</strong> ideas in your Topic Cluster(s).`;

				}

			}

		}
		
	},
	mounted () {

		this.reloadInstructionalTips();

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.keyword-stats {

	.keyword-stat {

		display: flex;
		margin-bottom: 20px;
		padding: 15px 15px 15px 0;
		-webkit-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
		-moz-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
		box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.2);
		cursor: pointer;

		&:hover {

			-webkit-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.5);
			-moz-box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.5);
			box-shadow: 0px 0px 15px -6px rgba(0, 0, 0, 0.5);

		}

		&.hide {

			display: none;

		}

		.doughnut {

			padding: 0;	
			margin: 0 10px 0.5%;
			
			&.noCount {

				.opacity(0.75);

			}

		}

		.content {

			.title {

				font-size:20px;
				padding: 0;
				margin: 0;

			}

			p {

				font-size:14px;
				padding: 0;
				margin: 0;

			}

			.status {

				display: inline-block;
				text-decoration: none;
				background-color: #394559;
				color: #fff;
				-webkit-border-radius: 5px;
				-moz-border-radius: 5px;
				border-radius: 5px;
				border: 2px solid #394559;
				padding: 2px 4px;
				font-size: 12px;
				margin-top: 0;
				-webkit-transition: all .25s linear;
				-moz-transition: all .25s linear;
				-o-transition: all .25s linear;
				transition: all .25s linear;
				margin: 8px 0;

				&.green {

					background-color: @green;
					border-color: @green;

				}

				&.orange {

					background-color: @orange;
					border-color: @orange;

				}

				&.orange2 {

					background-color: @formDefaultColour;
					border-color: @formDefaultColour;
					margin-left: 10px;

				}

				&.red {

					background-color: @red;
					border-color: @red;

				}

			}

		}

		&.no-doughnut {

			.content {

				padding-left: 20px;

			}

		}

	}

}
@media screen and (min-width: 768px) {
	.keyword-stats {

		display: flex;
  		flex-wrap: wrap;

		.keyword-stat {

			width: 49%;

			&:nth-child(odd) {

				margin-right: 2%;

			}

		}

	}
}
@media screen and (min-width: 1024px) {
	.keyword-stats {

		margin-top: 20px;

		.keyword-stat {

			&:first-child {

				

			}

		}

	}
}

@media screen and (min-width: 1440px) {
	.keyword-stats {

		.keyword-stat {

			width: 32.3%;

			&:nth-child(odd) {

				margin-right: 0;

			}

			&:nth-child(2), &:nth-child(5), &:nth-child(8) {

				margin-right: 1.5%;
				margin-left: 1.5%;

			}

		}

	}
}
</style>